module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/sd-card-fee1c492ffd423a92eebbea5516d2c76.svg";